<template>
  <div
    class="shadow-scroll-container"
    :class="{
      active: !disabled,
      scrolled: hasScroll,
    }"
  >
    <div
      ref="top"
      class="shadow-top"
      :class="{
        active: !disabled && topShadowActive,
      }"
    ></div>

    <div :id="`scroll-container-${_uid}`" ref="container" class="scroll-container" @scroll="update">
      <div class="scroll-container__content">
        <slot></slot>
      </div>
    </div>

    <div
      ref="bottom"
      class="shadow-bottom"
      :class="{
        active: !disabled && bottomShadowActive,
      }"
    ></div>

    <div v-if="withTopScroller" class="shadow-scroll-container__top">
      <top-button :id="`top-button-${_uid}`" class="top-button" :root="`#scroll-container-${_uid}`" />
    </div>
  </div>
</template>

<script>
import TopButton from "@/components/top-button";

export default {
  name: "shadow-scroll-container",
  components: { TopButton },
  props: ["disabled", "withTopScroller"],
  data() {
    return {
      hasScroll: false,
      topShadowActive: false,
      bottomShadowActive: false,
    };
  },
  watch: {
    disabled() {
      this.update();
    },
  },
  mounted() {
    this.update();
    this._cb = () => this.update();
    window.addEventListener("resize", this._cb);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this._cb);
  },
  methods: {
    update() {
      const scrollableElement = this.$refs.container;

      if (this.disabled) {
        this.hasScroll = false;
        this.topShadowActive = false;
        this.bottomShadowActive = false;
        return;
      }

      if (scrollableElement) {
        const { scrollHeight, clientHeight, scrollTop } = scrollableElement;

        this.$emit("scroll", scrollTop);
        
        if (scrollHeight > clientHeight) {
          this.hasScroll = true;
          this.topShadowActive = scrollTop !== 0;
          this.bottomShadowActive = scrollTop + clientHeight < scrollHeight - 5;
        } else {
          this.hasScroll = false;
          this.topShadowActive = false;
          this.bottomShadowActive = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.shadow-scroll-container {
  position: relative;
  display: flex;
  flex-direction: column;
  margin-right: -15px;

  &__top {
    position: relative;

    .top-button {
      position: absolute;
      right: 10px;
      bottom: 10px;
      z-index: 2;
      cursor: pointer;
    }
  }

  .shadow-top {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    opacity: 0;
    height: 30px;
    width: 100%;
    pointer-events: none;
    -webkit-transition: 0.2s;
    transition: 0.2s;

    &.active {
      opacity: 1;
      background: -webkit-gradient(
        linear,
        left bottom,
        left top,
        color-stop(16.13%, rgba(255, 255, 255, 0)),
        color-stop(100%, #ffffff)
      );
    }
  }

  .shadow-bottom {
    position: absolute;
    background: transparent;
    bottom: 0;
    left: 0;
    height: 30px;
    width: 100%;
    opacity: 0;
    pointer-events: none;
    -webkit-transition: 0.2s;
    transition: 0.2s;

    &.active {
      opacity: 1;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) 16.13%, #ffffff 100%);
    }
  }

  .scroll-container {
    flex-grow: 1;
    flex-basis: 100%;
    width: 100%;
    padding-right: 15px;
    max-height: 100%;

    &::-webkit-scrollbar {
      width: 4px;
      height: 100%;
    }

    &::-webkit-scrollbar-thumb {
      background: $color-secondary;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: $color-border-alt;
    }

    @media screen and (max-width: 700px) {
      width: 100%;

      // &::-webkit-scrollbar {
      //   width: 0px;
      // }
    }
  }

  &.active {
    .scroll-container {
      overflow-y: auto;
    }
  }
}
</style>
